import { useQuery } from '@tanstack/react-query';
import { surveyJsConnection } from '~/pages/api/quizzes';

export function surveyJsConnectionKey() {
   return ['surveyjs-connection'];
}

export function useSurveyJsConnection() {
   const queryFunction = async () => {
      return await surveyJsConnection();
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: surveyJsConnectionKey(),
   });
}
